import React, { Component } from "react";
// import { withLocalize } from "react-localize-redux";
import "./style.scss";
import PitcherContent from "./pitcher-content";
import BatterContent from "./batter-content";
import { connect } from "react-redux";

import {
    ACTIONS_MASTER, getYearData
} from './../../../../actions/master';
import Loading from "../../../../components/loading";
import DatePicker from 'react-datepicker';
import moment from 'moment';


class PerformanceByCondition extends Component {

    constructor(props) {

        super(props);
        this.state = {
            years: [],
            id: props.match.params.id,
            selectDateFrom: new Date(),
            selectDateTo: new Date(),
            datePickerFrom: new Date(),
            datePickerTo: new Date(),
            showLoading: false,
            tab: null
        }
    }

    componentDidMount() {
        this.setState({tab: (this.props.defaultTab == 'pitcher') ? 'pitcher' : 'batter'})
        this.setState({showLoading: true});
        this.props.getYearData();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps && nextProps.response && nextProps.response !== this.state.years) {
            if (nextProps.status === ACTIONS_MASTER.GET_YEAR_SUCCESS) {
                const year = nextProps.response[0].year.toString();
                this.setState({
                    showLoading: false,
                    years: nextProps.response,
                    datePickerFrom: moment(year + '/03/01').toDate(),
                    datePickerTo: moment(year + '/11/30').toDate(),
                    selectDateFrom: moment(year + '/03/01').toDate(),
                    selectDateTo: moment(year + '/11/30').toDate()
                })
            }
        }
    }

    yearSelect(year) {
        this.setState({datePickerFrom: moment(year + '/03/01').toDate()})
        this.setState({datePickerTo: moment(year + '/11/30').toDate()})
    }

    notificationSearch() {
        this.setState({
            selectDateFrom: this.state.datePickerFrom,
            selectDateTo: this.state.datePickerTo
        })
    }

    render() {
        return (
            <div className="condition">
                <div className="condition-control">
                    <div className="wrapper-tab">
                        <button onClick={() => this.setState({tab: 'pitcher'})} className={`tablinks ${(this.state.tab === 'pitcher') && ' active'}`}>投手</button>
                        <button onClick={() => this.setState({tab: 'batter'})} className={`tablinks ${(this.state.tab === 'batter') && ' active'}`}>打者</button>
                    </div>
                    <select onChange={ev => this.yearSelect(ev.target.value)} className="form-control">
                        {
                            this.state.years.map((item, index) =>
                                <option key={index.toString()}>{item.year}</option>)
                        }
                    </select>
                    <DatePicker
                        className='time-option'
                        dateFormat="yyyy/MM/dd"
                        selected={this.state.datePickerFrom}
                        onChange={date => {
                            const params = {datePickerFrom: date};
                            if (date > this.state.datePickerTo)  {
                                params.datePickerTo = date;
                            }
                            this.setState(params);
                        }}
                        selectsStart
                        startDate={this.state.datePickerFrom}
                        endDate={this.state.datePickerTo}
                        placeholderText="年/月/日"
                        strictParsing
                        disabledKeyboardNavigation
                    />
                    <span style={{ margin: '0 8px', 'fontSize': '39px'}}>~</span>
                    <DatePicker
                        className='time-option'
                        dateFormat="yyyy/MM/dd"
                        selected={this.state.datePickerTo}
                        onChange={date => {
                            const params = {datePickerTo: date};
                            if (date < this.state.datePickerFrom) {
                                params.datePickerFrom = date;
                            }
                            this.setState(params);
                        }}
                        selectsEnd
                        startDate={this.state.datePickerFrom}
                        endDate={this.state.datePickerTo}
                        placeholderText="年/月/日"
                        strictParsing
                        disabledKeyboardNavigation
                    />
                    <div onClick={() => this.notificationSearch()} className='btn-search-player'>
                        <img alt="filter" src='/img/ic_search_blue.svg'/>
                        <span>検索を実行</span>
                    </div>
                </div>

                <div className="condition-content">
                    <div className="tabcontent" style={(this.state.tab === 'pitcher') ? {display:'block'} : {display:'none'}}>
                        <PitcherContent id={this.state.id} tab={this.state.tab} date_from={this.state.selectDateFrom} date_to={this.state.selectDateTo} history={this.props.history} />
                    </div>

                    <div className="tabcontent" style={(this.state.tab === 'batter') ? {display:'block'} : {display:'none'}}>
                        <BatterContent id={this.state.id} tab={this.state.tab} date_from={this.state.selectDateFrom} date_to={this.state.selectDateTo} history={this.props.history} />
                    </div>
                </div>
                <Loading show={this.state.showLoading} />
            </div>
        )
    }
}

const mapStateToProps = ({ master }) => {

    return {
        response: master.response,
        status: master.status,
        message: master.message
    };
}

const mapDispatchToProps = dispatch => {
    return {
        getYearData: () => {
            dispatch(getYearData());
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(PerformanceByCondition);